import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

// Values
export const CaseAccessMode = schemas.CaseAccessModeEnum
export const CaseStatus = schemas.StatusEnum
export const NumberInputComparisonOperator = schemas.NumberInputComparisonOperatorEnum
export const ProcessStatus = schemas.ProcessStatusEnum
export const WorkflowStatus = schemas.Active1Enum
export const ValueTypeEnum = schemas.ValueTypeEnum

// Types
export type CaseAccessModeEnum = z.infer<typeof schemas.CaseAccessModeEnum>
export type AnnotatedDocument = z.infer<typeof schemas.AnnotatedDocument>
export type Case = z.infer<typeof schemas.Case>
export type Case2 = z.infer<typeof schemas.Case2>
export type CaseCard = z.infer<typeof schemas.CaseCard>
export type CaseIdentity = z.infer<typeof schemas.CaseIdentity>
export type CasesTableRow = z.infer<typeof schemas.CasesTableRow>
export type CaseAutomationEventLog = z.infer<typeof schemas.CaseAutomationEventLog>
export type CaseEventLog = z.infer<typeof schemas.CaseEventLog>
export type CaseEventType = z.infer<typeof schemas.AddCaseLocationEnum>
export type CaseStatusEnum = z.infer<typeof schemas.StatusEnum>
export type CaseWithLocation = z.infer<typeof schemas.CaseWithLocation>
export type CasesTab1 = z.infer<typeof schemas.CasesTab1>
export type CasesConfig1 = z.infer<typeof schemas.CasesConfig1>
export type CaseFilterRequest = z.infer<typeof schemas.CaseFilter>
export type CaseSortEnum = z.infer<typeof schemas.CaseSortEnum>
export type Comment = z.infer<typeof schemas.Comment>
export type CommentThread = {
  id: string
  form: string
  input?: string | null
  resolved: boolean
  comments: Comment[]
}
export type DigestFrequencyEnum = z.infer<typeof schemas.DigestFrequencyEnum>
export type DocumentStep = z.infer<typeof schemas.DocumentStep>
export type DocumentStepId = z.infer<typeof schemas.DocumentStepIdField>
export type DocumentTemplate = z.infer<typeof schemas.DocumentTemplate>
export type DocumentTemplateId = z.infer<typeof schemas.DocumentTemplateIdField>
export type EmailAddressResult = z.infer<typeof schemas.EmailAddressResult>
export type Identity0 = z.infer<typeof schemas.Identity0>
export type Identity1 = z.infer<typeof schemas.Identity1>
export type Identity2 = z.infer<typeof schemas.Identity2>
export type NumberComparison = z.infer<typeof schemas.NumberComparison>
export type NumberInputComparisonOperatorEnum = z.infer<
  typeof schemas.NumberInputComparisonOperatorEnum
>

export function identity1ToIdentity0(i1: Identity1): Identity0 {
  return {
    id: i1.id,
    contact_id: i1.contact_id,
    handle: i1.handle,
    name: i1.name,
    image: i1.image,
    stripe_id: i1.stripe_id,
    email: i1.email,
  }
}

export type DatetimeStep = z.infer<typeof schemas.DatetimeStep>
export type InputCreate = z.infer<typeof schemas.InputCreate>
export type Input1 = z.infer<typeof schemas.Input1>
export type IdentityStep = z.infer<typeof schemas.IdentityStep>
export type FileStep = z.infer<typeof schemas.FileStep>
export type LocationStep = z.infer<typeof schemas.LocationStep>
export type NumberStep = z.infer<typeof schemas.NumberStep>
export type SignatureStep = z.infer<typeof schemas.SignatureStep>
export type ValueType = z.infer<typeof schemas.ValueTypeEnum>

export type Notification1 = z.infer<typeof schemas.Notification1>

export type Process = z.infer<typeof schemas.Process>
export type Process0 = z.infer<typeof schemas.Process0>
export type Process1 = z.infer<typeof schemas.Process1>
export type ProcessStatusEnum = z.infer<typeof schemas.ProcessStatusEnum>
export type ProcessSummary = z.infer<typeof schemas.ProcessSummary>
export type Workflow = z.infer<typeof schemas.Workflow>
export type WorkflowStatusEnum = z.infer<typeof schemas.Active1Enum>

export type Bill0 = z.infer<typeof schemas.Bill0>
export type BillStep1 = z.infer<typeof schemas.BillStep1>
export type ChargeSubstep = z.infer<typeof schemas.ChargeSubstep>
export type ChargeSubstepCreate = z.infer<typeof schemas.ChargeSubStepCreate>
export type Form0 = z.infer<typeof schemas.Form0>
export type Task1 = z.infer<typeof schemas.Task1>
export type Section = z.infer<typeof schemas.Section>
